import View from './View.vue';
import Edit from './Edit.vue';



export default {
	View,
	Edit
}
